import { Amplify, Auth } from 'aws-amplify'
import awsconfig from '../../aws-exports'

Amplify.configure(awsconfig)

// Call AWS to update User's Name
async function updateUserName(firstName, lastName) {
  const user = await Auth.currentAuthenticatedUser()
  return Auth.updateUserAttributes(user, {
    'custom:firstName': firstName,
    'custom:lastName': lastName,
  })
}

export default updateUserName
